import React, { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import { deleteSection, fetchSectionList } from "../actions/section";
import { useSelector } from "react-redux";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { useTranslation } from "react-i18next";
import AggridTable from "../components/Admin/Reusable/AggridTable";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { toast } from "react-toastify";
import { createDateColumn } from "../utils/agGridDateColumn";

const SectionList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { sectionList } = useSelector((state) => state.sectionReducer);

  //breadcrumb
  const translateModule = "section";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  useEffect(() => {
    dispatch(fetchSectionList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id || !params.data.type) return null;
    return (
      <ButtonColumn
        editLink={`/section-edit/` + params.data.id}
        value={params}
      />
    );
  };

  const columnDefs = [
    {
      headerName: "Master kanal",
      field: "type",
      filter: "agTextColumnFilter",
      minWidth: 140,
      flex: 1,
    },
    {
      headerName: "Cena",
      field: "price",
      filter: "agNumberColumnFilter",
      width: 140,
    },
    {
      headerName: "Trajanje pristupa (dana)",
      field: "accessDuration",
      filter: "agNumberColumnFilter",
      width: 220,
    },
    {
      headerName: "Na prodaju",
      field: "shoppable",
      filter: "agSetColumnFilter",
      width: 140,
    },
    {
      headerName: "Na popustu",
      field: "discount",
      filter: "agSetColumnFilter",
      width: 140,
    },
    {
      headerName: "Besplatan",
      field: "free",
      filter: "agSetColumnFilter",
      width: 140,
    },
    {
      headerName: "Cena sa popustom",
      field: "discountPrice",
      filter: "agNumberColumnFilter",
    },

    createDateColumn("Popust od", "discountStart"),
    createDateColumn("Popust do", "discountEnd"),
    createDateColumn("Datum kreiranja", "createdAt"),
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 60,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={`${translateModule}${pageType}`}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        reloadData={() =>
          dispatch(fetchSectionList()).then(() => {
            toast.success("Podaci su uspešno osveženi", {
              theme: "colored",
            });
          })
        }
        rowData={sectionList}
        columnDefs={columnDefs}
        gridStateKey="section-list"
      />
    </Fragment>
  );
};

export default SectionList;
